import React, { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { userSelector } from "Utils/selectors";
import BenefitsPopUp from "./BenefitsPopUp";
import VerificationEmailPopUp from "./VerificationEmailPopUp";
import { openSignUpPopUp } from "./helpers";
import { useApiClient } from "Services/API/useApiClient";
import { ClaimVenueResult, VenueClaimClient } from "Services/API/API";

export interface ClaimProfilePopUpProps {
   toggle?: () => void;
   venueId: Guid;
}

const openManageVenue = (venueId?: string) => {
   window.open(`/managevenue/${venueId}/spaces`, "_self");
}

const ClaimProfilePopUp: React.FC<ClaimProfilePopUpProps> = ({
   toggle,
   venueId,
}) => {
   const [isOpenVerificationPopUp, setIsOpenVerificationPopUp] =
      useState(false);
   const [isLoading, setIsLoading] = useState(false);
   const isOpenSignUpPopUp = useSelector(
      (state) => state?.signingModal?.isOpen
   );
   const isOpenBenefitPopUp = !isOpenSignUpPopUp && !isOpenVerificationPopUp;
   const user = useSelector(userSelector);
   const venueClaimClient = useApiClient(VenueClaimClient);

   const claimFlow = useCallback(async () => {
      try {
         setIsLoading(true);
         const result = await venueClaimClient.claim(venueId, false);

         if (result === ClaimVenueResult.UnknownMemberNeedVerification) {
            setIsOpenVerificationPopUp(true);
         } else {
            if (result === ClaimVenueResult.KnownAdminClaimed && venueId) {
               openManageVenue(venueId)
            }
            toggle?.();
         }
      }
      finally {
         setIsLoading(false);
      }
   }, [venueClaimClient, toggle, venueId]);

   const onClaim = useCallback(async () => {
      if (user.isAuthenticated) {
         try {
            await claimFlow();
         } catch {
            toggle?.();
         }
      } else {
         openSignUpPopUp(() => claimFlow());
      }
   }, [claimFlow, user, toggle, venueId]);

   return (
      <>
         <BenefitsPopUp
            isOpen={isOpenBenefitPopUp}
            toggle={toggle}
            onClaim={onClaim}
            isLoading={isLoading}
         />
         <VerificationEmailPopUp
            isOpen={isOpenVerificationPopUp}
            toggle={toggle}
            venueId={venueId}
            email={user?.email}
         />
      </>
   );
};

export default ClaimProfilePopUp;
